import React, { useEffect, useState } from "react";
// import moment from "moment";
import history from "../../history";

import ReactHtmlParser from "react-html-parser";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Form,
} from "reactstrap";
import DesignCard from "../DesignCard";
import InputText from "../InputText";
import CustomButton from "../CustomButton";
import { fetchQueryParams } from "../../utils/comman";

import Loader from "../Loader";
import {
  helperFunctionForDate,
  helperFunctionForTime,
  helperFunctionForBooleanValue,
  helperFunctionForStatus,
  spaceValidation,
  specialCharacters,
} from "../../utils/helperFunction";
import UploadFile from "../UploadFile";
import { toast } from "react-toastify";
import Icon from "react-icons-kit";
import { close } from "react-icons-kit/fa/close";

import get from "lodash/get";

const _ = { get };

const initialState = {
  formId: "",
  status: "",
  rejectionReason: "",
  toggleRejectModal: false,
  images: [
    {
      image: null,
      preview: null,
    },
    {
      image: null,
      preview: null,
    },
    {
      image: null,
      preview: null,
    },
    {
      image: null,
      preview: null,
    },
    {
      image: null,
      preview: null,
    },
  ],

  hashtagText: "",
  hashtags: [],
  description: "",
};

function eventDetail(props) {
  let { elements } = props;
  const [state, setState] = useState(initialState);
  const [modal, setModal] = useState(false);

  const toggle = () => {
    state.hashtags = [];
    state.images = [
      {
        image: null,
        preview: null,
      },
      {
        image: null,
        preview: null,
      },
      {
        image: null,
        preview: null,
      },
      {
        image: null,
        preview: null,
      },
      {
        image: null,
        preview: null,
      },
    ];
    state.description = "";
    state.hashtagText = "";
    setState({ ...state });
    setModal(!modal);
  };

  useEffect(() => {
    let queryParams = props.query;
    if (props.selectedId) {
      props.handleFetchSingleEvent(props.selectedId);
    }
  }, [props.selectedId]);

  const handleGoBack = () => {
    props.handleToggleModel();
  };

  const handleGoBackFromModeration = () => {
    props.handleToggleModel();
  };

  const handleNameChange = (e) => {
    state[e.target.name] = e.target.value;
    setState({ ...state });
  };

  const handleChangeHashtag = (e) => {
    let value = e.target.value;
    if (value.match(spaceValidation) && !value.match(specialCharacters)) {
      state[e.target.name] = e.target.value;
      setState({ ...state });
    }
  };

  const handleToggleRejectModal = () => {
    state.toggleRejectModal = false;
    setState({ ...state });
  };

  const handleAddHashTag = () => {
    if (state.hashtagText) {
      state.hashtags.push(`#${state.hashtagText}`);
      state.hashtagText = "";
      setState({ ...state });
    }
  };

  const handleRemoveHasTag = (e, index) => {
    if (index > -1) {
      state.hashtags.splice(index, 1);
    }
    setState({ ...state });
  };

  const handleToUpdate = () => {
    const params = fetchQueryParams(props.query);
    history.push(`/event/update?id=${props.selectedId}`);
  };

  const handleToUpdateByAdmin = () => {
    const params = fetchQueryParams(props.query);
    history.push(
      `/event/event-update?id=${props.selectedId}&status=${props.status}`
    );
  };

  const handleImageChange = (e, idx) => {
    e.preventDefault();
    var fileTypes = ["jpg", "jpeg", "png"];
    if (e.target.files[0]) {
      var extension = e.target.files[0].name
          .split(".")
          .pop()
          .toLowerCase(), //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1;

      if (isSuccess) {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
          saveImage(reader.result, file, idx);
        };
        reader.readAsDataURL(file);
      } else {
        toast.error(
          _.get(
            elements,
            "branchCreationElement.imageValidationElement",
            "only '.jpg' , '.jpeg' , '.png' file types are accepted"
          )
        );
      }
    } else {
    }

    e.target.value = "";
  };
  const deleteImage = (idx) => {
    const newState = { ...state };
    const images = state.images.map((image) => ({ ...image }));
    newState.images = images;

    newState.images[idx].preview = null;
    newState.images[idx].image = null;

    setState(newState);
  };

  const saveImage = (preview, image, idx) => {
    const newState = { ...state };
    const images = state.images.map((image) => ({ ...image }));
    newState.images = images;

    newState.images[idx].preview = preview;
    newState.images[idx].image = image;

    setState(newState);
  };

  const handleStatusSubmit = (e, status) => {
    e.preventDefault();
    if (status === "REJECTED") {
      state.status = "REJECTED";
      state.toggleRejectModal = true;
      setState({ ...state });
    } else if (status === "APPROVED") {
      state.status = "APPROVED";
      setState({ ...state });
      let data = {
        eventId: props.selectedId,
        status: status,
        rejectionReason: "",
      };
      props.handleEventModeration(data, props.status);
      props.handleToggleModel();
    }
  };

  const handleSubmitRejection = (e) => {
    e.preventDefault();
    let data = {
      eventId: props.selectedId,
      status: state.status,
      rejectionReason: state.rejectionReason,
    };
    state.toggleRejectModal = false;
    setState({ ...state });
    props.handleEventModeration(data, props.status);
    props.handleToggleModel();
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let queryParams = props.query;
    const params = fetchQueryParams(queryParams);
    const formData = new FormData();

    const images = state.images.map((image) => {
      return image.image;
    });

    for (let image of images) {
      formData.append("images", image);
    }
    formData.append("activityId", props.selectedId);
    formData.append("category", "event");
    formData.append("description", state.description);
    formData.append("hashtag", JSON.stringify(state.hashtags));

    if (images[0] || images[1] || images[2] || images[3] || images[4]) {
      props.handleEventGallery(formData);
      setModal(!modal);
    } else {
      toast.error(
        _.get(
          elements,
          "branchCreationElement.imageValidationElem",
          "Upload Image"
        )
      );
    }
  };

  useEffect(() => {
    const newState = { ...state };
    state.rejectionReason = "";
    state.toggleRejectModal = false;
    setState(newState);
  }, []);

  return (
    <React.Fragment>
      <div className="hideSearch">
        {props.singleEventStatus && <Loader />}
        {props.moderateEventGalleryStatus && <Loader />}
        <Form>
          <Modal
            isOpen={modal}
            toggle={toggle}
            backdrop={true}
            centered={true}
            size="xl"
          >
            <ModalHeader toggle={toggle}>
              {_.get(
                elements,
                "branchCreationElement.galleryHeadingElement",
                "Gallery"
              )}
            </ModalHeader>
            <ModalBody>
              <div className="d-flex flex-row light_Scroll px-3 justify-content-between">
                {state.images.map((image, idx) => {
                  return (
                    <UploadFile
                      key={`image${idx}`}
                      id={`image${idx}`}
                      image={image}
                      handleImageChange={(e) => handleImageChange(e, idx)}
                      deleteImage={() => deleteImage(idx)}
                    />
                  );
                })}
              </div>
              <Row className="mt-3 pt-3">
                <Col xl={6} sm={12} className="mb-2 mb-lg-0">
                  <Row>
                    <Col xl={8} lg={8} className="mb-2 mb-lg-0">
                      <InputText
                        labelName={_.get(
                          elements,
                          "branchCreationElement.galleryHastagLabelElement",
                          "Hastags"
                        )}
                        inputType={"text"}
                        inputName={"hashtagText"}
                        customValue={state.hashtagText}
                        tooltip={""}
                        inputPlaceholder={_.get(
                          elements,
                          "branchCreationElement.galleryHastagPlaceholderElement",
                          "Enter Hastags"
                        )}
                        customOnChange={(e) => handleChangeHashtag(e)}
                      />
                    </Col>
                    <Col xl={4} lg={4} className="mb-2 mb-lg-0 ">
                      <div className="d-flex align-items-center h-100 mt-1 pt-1">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchCreationElement.galleryAddElement",
                            "Add"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={handleAddHashTag}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={12}>
                      <div className="d-flex flex-wrap hastag-wrapper">
                        {state.hashtags.map((item, index) => (
                          <span className="mr-2 border p-2 rounded position-relative d-flex mb-2">
                            <Icon
                              className="editIcon mr-2"
                              onClick={(e) => handleRemoveHasTag(e, index)}
                              icon={close}
                            />
                            <span>{item}</span>
                          </span>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6} sm={12} className="mb-2 mb-lg-0">
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.descriptionLabelElement",
                      "Description"
                    )}
                    inputType={"textarea"}
                    inputName={"description"}
                    customValue={state.description}
                    tooltip={""}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.descriptionGalleryPlaceholderElement",
                      "Enter Description"
                    )}
                    customOnChange={(e) => handleNameChange(e)}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                <CustomButton
                  customType={"submit"}
                  name={_.get(
                    elements,
                    "branchCreationElement.submitButtonElement",
                    "Submit"
                  )}
                  customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  customClick={handleSubmitForm}
                />
              </div>
            </ModalFooter>
          </Modal>
        </Form>

        {props.singleEvent !== null ? (
          <React.Fragment>
            <Card>
              <CardBody>
                <Row>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.eventNameElement",
                        "Event Name"
                      )}
                      titleName={props.singleEvent.eventName}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.startPointElement",
                        "Start Point"
                      )}
                      titleName={props.singleEvent.eventLocation}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.sourceLatElement",
                        "Source Latitude"
                      )}
                      titleName={props.singleEvent.sourcePoint.latitude}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.sourceLongElement",
                        "Source Longitude"
                      )}
                      titleName={props.singleEvent.sourcePoint.longitude}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.coordinatorNameElement",
                        "Event Coordinator Name"
                      )}
                      titleName={props.singleEvent.eventCoordinator.name}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.coordinatorEmailElement",
                        "Event Coordinator Email"
                      )}
                      titleName={props.singleEvent.eventCoordinator.email}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.coordinatorMobileElement",
                        "Event Coordinator Mobile"
                      )}
                      titleName={props.singleEvent.eventCoordinator.mobile}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.countryElement",
                        "Country"
                      )}
                      titleName={props.singleEvent.eventInfo.country}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.stateElement",
                        "State"
                      )}
                      titleName={props.singleEvent.eventInfo.state}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.cityElement",
                        "City"
                      )}
                      titleName={props.singleEvent.eventInfo.city}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.startDateElement",
                        "Start Date"
                      )}
                      titleName={helperFunctionForDate(
                        props.singleEvent.eventInfo.eventStartDateIso
                      )}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.startTimeElement",
                        "Start Time"
                      )}
                      titleName={helperFunctionForTime(
                        props.singleEvent.eventInfo.startTime
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.advanceBookingElement",
                        "Advance Booking"
                      )}
                      titleName={helperFunctionForBooleanValue(
                        props.singleEvent.advancedBooking
                      )}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.testRideElement",
                        "Test Ride"
                      )}
                      titleName={helperFunctionForBooleanValue(
                        props.singleEvent.testRide
                      )}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.hospitalityElement",
                        "Hospitality"
                      )}
                      titleName={helperFunctionForBooleanValue(
                        props.singleEvent.hospitality
                      )}
                    />
                  </Col>

                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.registrationFeeElement",
                        "Registration Fee"
                      )}
                      titleName={props.singleEvent.registrationFee}
                    />
                  </Col>

                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.moderationStatusElement",
                        "Moderation Status"
                      )}
                      titleName={helperFunctionForStatus(
                        props.singleEvent.moderationStatus,
                        elements
                      )}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.eventStatusElement",
                        "Event Status"
                      )}
                      titleName={helperFunctionForStatus(
                        props.singleEvent.eventStatus,
                        elements
                      )}
                    />
                  </Col>
                  <Col xl={6} lg={6} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.eventDescriptionElement",
                        "Description"
                      )}
                      titleName={ReactHtmlParser(
                        props.singleEvent.eventInfo.eventDescription
                      )}
                    />
                  </Col>
                  {/* <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "eventDetailElement.endTimeElement",
                        "End Time"
                      )}
                      titleName={helperFunctionForTime(
                        props.singleEvent.eventInfo.endTime
                      )}
                    />
                  </Col> */}
                </Row>
                {props.page === "list" ? (
                  <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "eventDetailElement.backButtonElement",
                        "Back"
                      )}
                      customClass={"btn-outline-dark bg-none btnthemeColor"}
                      customClick={() => handleGoBack()}
                    />

                    <CustomButton
                      customType={"submit"}
                      name={_.get(
                        elements,
                        "rideDetailElement.imageButtonElement",
                        "Add Image"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                      }
                      customClick={() => toggle()}
                    />

                    <CustomButton
                      customType={"submit"}
                      name={_.get(
                        elements,
                        "eventDetailElement.updateButtonElement",
                        "Update"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                      }
                      customClick={() => handleToUpdate()}
                    />
                  </div>
                ) : (
                  <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "eventDetailElement.backButtonElement",
                        "Back"
                      )}
                      customClass={"btn-outline-dark bg-none btnthemeColor"}
                      customClick={() => handleGoBackFromModeration()}
                    />

                    <CustomButton
                      customType={"submit"}
                      name={_.get(
                        elements,
                        "eventDetailElement.updateButtonElement",
                        "Update"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                      }
                      customClick={() => handleToUpdateByAdmin()}
                    />

                    {props.singleEvent.moderationStatus === "PENDING" ? (
                      <React.Fragment>
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "eventDetailElement.approveButtonElement",
                            "Approve"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => handleStatusSubmit(e, "APPROVED")}
                        />
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "eventDetailElement.disApproveButtonElement",
                            "Reject"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => handleStatusSubmit(e, "REJECTED")}
                        />
                      </React.Fragment>
                    ) : null}

                    {props.singleEvent.moderationStatus === "APPROVED" ? (
                      <React.Fragment>
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "eventDetailElement.disApproveButtonElement",
                            "Reject"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => handleStatusSubmit(e, "REJECTED")}
                        />
                      </React.Fragment>
                    ) : null}

                    {props.singleEvent.moderationStatus === "REJECTED" ? (
                      <React.Fragment>
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "eventDetailElement.approveButtonElement",
                            "Approve"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => handleStatusSubmit(e, "APPROVED")}
                        />
                      </React.Fragment>
                    ) : null}

                    {props.singleEvent.eventStatus === "COMPLETED" &&
                    props.displayName !== "Admin" ? (
                      <CustomButton
                        customType={"submit"}
                        name={_.get(
                          elements,
                          "rideDetailElement.imageButtonElement",
                          "Add Image"
                        )}
                        customClass={
                          "btn-outline-dark bg-none ml-2 btnthemeColor"
                        }
                        customClick={() => toggle()}
                      />
                    ) : null}
                  </div>
                )}
              </CardBody>
            </Card>
          </React.Fragment>
        ) : null}
      </div>
      <Modal isOpen={state.toggleRejectModal}>
        <ModalHeader toggle={handleToggleRejectModal}>
          {_.get(
            elements,
            "eventDetailElement.rejectionElement",
            "Rejection Reason"
          )}
        </ModalHeader>
        <ModalBody>
          <InputText
            inputType={"textarea"}
            inputName={"rejectionReason"}
            customValue={state.rejectionReason}
            customOnChange={(e) => handleNameChange(e)}
          />
        </ModalBody>
        <ModalFooter>
          <CustomButton
            customType={"submit"}
            name={_.get(
              elements,
              "eventDetailElement.rejectionButtonElement",
              "Reject"
            )}
            customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
            customClick={(e) => handleSubmitRejection(e)}
          />
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}

export default eventDetail;
